import {EtatCarte} from "@domain/admin/ca/ope-log-error";

/**
 * DTO représentant le détail d'une opération carte
 */
export class OpeCarteDetail {
    idOpeCarte: string;
    numCarteClair: string;
    collab: string;
    codeCollab: string;
    matricule: string;
    date: Date;
    enseigne: string;
    localite: string;
    pays: string;
    libelleMedoc: string;
    libelleMcc: string;
    montant: number;
    devise: string;
    erreur: EtatCarte;
    libelleErreur: string;
    libelleSolution: string;

    constructor(dto?: any) {
        if (dto) {
            Object.assign(this, dto);
            if (dto.date) {
                this.date = new Date(dto.date);
            }
        }
    }
}